import * as S from './styles'

const NotificationDropdownFooter: React.FC = () => {
  return <S.Footer>Ver Tudo</S.Footer>
}

export default NotificationDropdownFooter
